// 模块名称__数据描述_数据操作. BEM
export const SEAL_TYPE = 'SEAL_TYPE';
export const SEAL_COLOR = 'SEAL_COLOR';
export const SEAL_FORM = 'SEAL_FORM';
export const SEAL_SHOW_URI = 'SEAL_SHOW_URI';
export const PER_ADD_TYPE = 'PER_ADD_TYPE';
export const INFO_GET_STORE = 'INFO_GET_STORE';
export const INFO_SET_STORE = 'INFO_SET_STORE';
// 模板搜索内容 templateSearchContent
export const TEMPLATE_SEARCH_CONTENT = 'TEMPLATE_SEARCH_CONTENT';
// 模板 当前 page templateCurrentPage
export const TEMPLATE_CURRENT_PAGE = 'TEMPLATE_CURRENT_PAGE';
// 批量签署的数据
export const BATCH_LIST = 'BATCH_LIST';
// 其他页面上传文件 files保存
export const FILES_UPLOAD_OTHER = 'FILES_UPLOAD_OTHER';



// WEBPACK FOOTER //
// ./src/pages/admin/store/mutation-types.js